import React from 'react'
import { Certificate } from './Interfaces'

// Kendo components
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, FormElement } from '@progress/kendo-react-form'
import { FormDate, FormInput } from './FormInput'

import styles from '.././EDIForms.module.scss'
import { AWCButton, BUTTON_TYPES } from '../../GlobalComponents/Inputs/Inputs'

export const EditCertificateModal: React.FC<{
    certificate?: Certificate
    expirationDate: string
    cancelEdit: () => void
    onSubmit: (event: any) => void
    handleExpirationDateChange: (event: any) => void
}> = (props) => {
    return (
        <Dialog width="30%" style={{ minWidth: 1000 }}>
            {props.certificate && (
                <Form
                    onSubmitClick={props.onSubmit}
                    initialValues={props.certificate}
                    render={(formRenderProps) => {
                        const dateValue = new Date(props.expirationDate)

                        return (
                            <FormElement>
                                <div className={styles.wrapHeader}>
                                    <div className={`k-form-buttons ${styles.buttonLeft}`}>
                                        <AWCButton
                                            type={BUTTON_TYPES.PRIMARY}
                                            onClick={formRenderProps.onSubmit}
                                            style={{
                                                width: 150,
                                            }}
                                        >
                                            Update Certificate
                                        </AWCButton>
                                    </div>
                                    <div className={`k-form-buttons ${styles.buttonRight}`}>
                                        <AWCButton
                                            type={BUTTON_TYPES.SECONDARY}
                                            onClick={props.cancelEdit}
                                            style={{ width: 50 }}
                                        >
                                            <span className="k-icon k-i-close"></span>
                                        </AWCButton>
                                    </div>
                                </div>

                                <div className={styles.wrap}>
                                    <FormDate
                                        label="Expiration Date"
                                        name="ExpirationDate"
                                        required={true}
                                        dateAsDate={dateValue}
                                        onDateChange={props.handleExpirationDateChange}
                                    />
                                </div>

                                <div className={styles.wrap}>
                                    <FormInput
                                        length="medium"
                                        label="Partner Certificate Name"
                                        name="PartnerCertificateName"
                                        maxChar={200}
                                    />
                                </div>

                                <div className={styles.wrap}>
                                    <FormInput
                                        length="medium"
                                        label="Signing Certificate Name"
                                        name="SigningCertificateName"
                                        maxChar={200}
                                    />
                                </div>

                                <div className={styles.blockEnd} />
                            </FormElement>
                        )
                    }}
                />
            )}
        </Dialog>
    )
}
